import { z } from 'zod';
import { PromotionCreditType } from '../../constants/promotion-credit-type.js';
import { optionalClientGeneratedUuidString, optionalTrimmedNullableString, requiredUuidString, } from '../zod-helpers/index.js';
import { PROMOTION_CREDIT_CONSTRAINTS } from './constraints.js';
import { creditAmountInput } from './credit-amount-input.js';
import { creditDateInput } from './credit-date-input.js';
import { INVALID_IDEMPOTENCY_KEY_MESSAGE } from './invalid-idempotency-key-message.js';
import { promotionCreditLineInputSchema } from './line-input.js';
import { promotionCreditLinesMessage } from './lines-message.js';
import { lowercaseUuid } from './lowercase-uuid.js';
import { OVERPAYMENT_NOT_ISSUABLE_MESSAGE } from './overpayment-not-issuable-message.js';
import { promotionLinkInput } from './promotion-link-input.js';
import { refineExpirationAfterIssued } from './refine-credit-dates.js';
import { refineCreditLines } from './refine-credit-lines.js';
export const issuePromotionCreditInputSchema = z
    .object({
    customerId: requiredUuidString('Customer is required.', 'Invalid customer selection.').transform(lowercaseUuid),
    brandId: requiredUuidString('Brand is required.', 'Invalid brand selection.').transform(lowercaseUuid),
    promotionCreditTypeId: z
        .enum(PromotionCreditType, 'Invalid credit type selection.')
        .refine((type) => type !== PromotionCreditType.OVERPAYMENT, {
        message: OVERPAYMENT_NOT_ISSUABLE_MESSAGE,
    }),
    amount: creditAmountInput,
    dateApplicable: creditDateInput('Issued date').nullish(),
    expirationDate: creditDateInput('Expiration date').nullish(),
    details: optionalTrimmedNullableString(PROMOTION_CREDIT_CONSTRAINTS.details.maxLength),
    notes: optionalTrimmedNullableString(PROMOTION_CREDIT_CONSTRAINTS.notes.maxLength),
    promotionId: promotionLinkInput,
    lines: z
        .array(promotionCreditLineInputSchema)
        .max(PROMOTION_CREDIT_CONSTRAINTS.lines.max, promotionCreditLinesMessage)
        .nullish(),
    idempotencyKey: optionalClientGeneratedUuidString(INVALID_IDEMPOTENCY_KEY_MESSAGE),
})
    .superRefine((value, context) => {
    refineExpirationAfterIssued(value, context);
    refineCreditLines(value, context);
    if (!value.lines || value.lines.length === 0)
        return;
    if (value.promotionId == null) {
        context.addIssue({
            code: 'custom',
            message: 'Credit lines need a linked promotion.',
            path: ['promotionId'],
        });
    }
    if (value.promotionCreditTypeId !== PromotionCreditType.PROMOTION) {
        context.addIssue({
            code: 'custom',
            message: 'Credit lines are only for Promotion credits.',
            path: ['promotionCreditTypeId'],
        });
    }
});
//# sourceMappingURL=issue-input.js.map